import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOneClickDone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z",
			fill: "#EFFCF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z",
			stroke: "#7DD5A8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 8.13333L6.86667 10L10.8667 6",
			stroke: "#7DD5A8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOneClickDone;
